import React, { useState } from 'react';
import { Navbar } from './Navbar';
import { Hero } from './sections/Hero';
import { Problema } from './sections/Problema';
import { Solucion } from './sections/Solucion';
import { ComoFunciona } from './sections/ComoFunciona';
import { Transformacion } from './sections/Transformacion';
import { Aprenderas } from './sections/Aprenderas';
import { Oferta } from './sections/Oferta';
import { Bonos } from './sections/Bonos';
import { Testimonios } from './sections/Testimonios';
import { Creador } from './sections/Creador';
import { Garantia } from './sections/Garantia';
import { FAQ } from './sections/FAQ';
import { CTAFinal } from './sections/CTAFinal';
import { Footer } from './Footer';
import { StickyBar } from './StickyBar';
import { QuizModal } from './QuizModal';
export function SalesPage() {
  const [isQuizOpen, setIsQuizOpen] = useState(false);
  return <main className="relative bg-deep min-h-screen" data-id="element-63">
      <Navbar data-id="element-64" />
      <Hero onOpenQuiz={() => setIsQuizOpen(true)} data-id="element-65" />
      <Problema data-id="element-66" />
      <Solucion data-id="element-67" />
      <ComoFunciona data-id="element-68" />
      <Transformacion data-id="element-69" />
      <Aprenderas data-id="element-70" />
      <Oferta data-id="element-71" />
      <Bonos data-id="element-72" />
      <Testimonios data-id="element-73" />
      <Creador data-id="element-74" />
      <Garantia data-id="element-75" />
      <FAQ data-id="element-76" />
      <CTAFinal data-id="element-77" />
      <Footer data-id="element-78" />

      <StickyBar data-id="element-79" />
      <QuizModal isOpen={isQuizOpen} onClose={() => setIsQuizOpen(false)} data-id="element-80" />
    </main>;
}